// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3E3II","content":"styles_content__2f9ta"};